import { useCallback, useState } from 'react';
import { useChannelSubscription, ClickToCallModalPayload, QueueEvent } from '@frontend/queue';
import { useModalControl } from '@frontend/design-system';
import { ClickToCallSelection } from './selection-modal/click-to-call-selection';

interface ModalState {
  dialNumber: string;
  isLoading: boolean;
  outboundNumber?: string;
}

export const GlobalClickToCallModal = () => {
  const modal = useModalControl();
  const [modalState, setModalState] = useState<ModalState>({
    dialNumber: '',
    isLoading: false,
  });

  const handleModalEvent = useCallback(
    (event: QueueEvent<ClickToCallModalPayload>) => {
      if (event.payload.type === 'click-to-call') {
        const { dialNumber, isLoading, outboundNumber } = event.payload;

        setModalState({
          dialNumber,
          isLoading,
          outboundNumber,
        });

        modal.triggerProps.onClick();
        return true;
      }

      return false;
    },
    [modal]
  );

  useChannelSubscription('clickToCallModal', handleModalEvent);

  const handleClose = useCallback(() => {
    setModalState({
      dialNumber: '',
      isLoading: false,
    });
    modal.closeModal();
  }, [modal]);

  return (
    <ClickToCallSelection
      modal={{
        ...modal,
        closeModal: handleClose,
      }}
      context={{
        dialNumber: modalState.dialNumber,
        isLoading: modalState.isLoading,
        outboundNumber: modalState.outboundNumber,
      }}
    />
  );
};
